export const FETCH_USERS = 'FETCH_USERS';
export const CREATE_USER = 'CREATE_USER';

/* use the state type FETCH_USERS CREATE_USER  */



